import { LOAD_APP_CONFIG } from '../actionTypes';

const initialState = {};

const appConfig = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_APP_CONFIG: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};

export default appConfig;



// WEBPACK FOOTER //
// ./src/redux/reducers/appConfig.js